"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIrcsSheet = void 0;
const index_1 = require("../../index");
const makeIrcsSheet = () => {
    return [
        {
            '@type': 'grid',
            'key': 'f659d8f1-86b1-4ce1-86b5-97c92581d691',
            columns: 1,
            children: [
                {
                    '@type': 'card',
                    key: '54e088db-dcb8-4697-a8b7-1cf8a47c7fd5',
                    title: "Signalement d'interventions à caractère social",
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: 'd5a34e77-632c-4b89-805c-5e5d1852d35e',
                            columns: 1,
                            children: [...index_1.template.ircsSheetConcerne],
                        },
                    ],
                },
                {
                    '@type': 'card',
                    key: '669515b1-8357-4c14-aa8b-40859626134b',
                    title: 'Personne "ressource" ou représentant légal',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: '2d99270e-d78d-4cca-b5c3-329b29b4c31b',
                            columns: 1,
                            children: [...index_1.template.ircsSheetRessource],
                        },
                    ],
                },
                {
                    '@type': 'card',
                    key: '2e9c466d-72db-478a-8a25-ecf7f70a0b04',
                    title: 'Signalement',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: '8f40777a-a5e6-4bc6-b715-c0216feb5aae',
                            columns: 1,
                            children: [...index_1.template.ircsSheetSignalement],
                        },
                    ],
                },
            ],
        },
    ];
};
exports.makeIrcsSheet = makeIrcsSheet;
